export const fields = {
    computed: {
      fields() {
        return [
          {
            label: 'No. Invoice',
            key: 'number',
            isSortable: true,
            isRedirectable: true,
            tdAttr: {
              style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px',
            },
            thAttr: {
              style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
            },
          },
          {
            label: 'Status Invoice',
            key: 'status.name',
            isSortable: true,
            tdAttr: {
              style: 'left:229.5px;position:sticky;',
            },
            thAttr: {
              style: 'left:229.5px;position:sticky;z-index:1;',
            },
          },
          { label: 'Nama Pelanggan', key: 'customer.name', isSortable: true },
          { label: 'Tanggal Dibuat', key: 'created_date', isSortable: true },
          { label: 'Jatuh Tempo', key: 'due_date', isSortable: true },
          { label: 'Nominal', key: 'amount', isSortable: true },
        ]
      }
    }
  }